import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('studentassesment').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('studentassesment').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('studentassesment').select().eq('id', id)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const { data, error } = await supabase.from('studentassesment').select().eq('studentId', id).order('order')
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('studentassesment').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	const { data, error } = await supabase.from('studentassesment').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('studentassesment').delete().eq('id', id)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
